import { defineStore, storeToRefs } from 'pinia';

export const HITL_COMMON_DEBUG = 'HITL-Debug';
export const HITL_WS_DEBUG = 'HITL-WS-Debug';
export const HITL_VOICE_DEBUG = 'HITL-Voice-Debug';

export const useAppConfigStore = defineStore('HITL-App-Config', {
  state: () => {
    return {
      isDebug: localStorage.getItem(HITL_COMMON_DEBUG) === 'true',
      isWSDebug: localStorage.getItem(HITL_WS_DEBUG) === 'true',
      isVoiceDebug: localStorage.getItem(HITL_VOICE_DEBUG) === 'true',
    };
  },
});

export const useAppConfig = () => storeToRefs(useAppConfigStore());
